import { Card, CardContent } from '@/components/ui/card';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <Link to="/" className="inline-flex items-center text-blue-600 hover:text-blue-700 mb-6">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Torna indietro
        </Link>
        
        <Card>
          <CardContent className="p-8 prose max-w-none">
            <h1 className="text-3xl font-bold text-gray-900 mb-6">Informativa sulla Privacy</h1>
            <p className="text-sm text-gray-600 mb-8">Ultimo aggiornamento: Novembre 2025</p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">1. Titolare del Trattamento</h2>
            <p className="text-gray-700 mb-4">
              Il Titolare del trattamento dei dati è ZonePass, con sede legale in [Indirizzo], 
              P.IVA [Numero], contattabile all'indirizzo email: privacy@zonepass.io
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">2. Dati Raccolti</h2>
            <p className="text-gray-700 mb-4">Raccogliamo i seguenti dati personali:</p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Nome e cognome</li>
              <li>Indirizzo email</li>
              <li>Numero di telefono</li>
              <li>Dati di fatturazione (per organizzatori): P.IVA, Codice Fiscale, indirizzo</li>
              <li>Dati di navigazione e cookies</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">3. Finalità del Trattamento</h2>
            <p className="text-gray-700 mb-4">I dati vengono trattati per:</p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Erogazione del servizio di biglietteria</li>
              <li>Gestione degli ordini e dei biglietti</li>
              <li>Comunicazioni relative all'evento</li>
              <li>Fatturazione e adempimenti fiscali</li>
              <li>Marketing (solo previo consenso)</li>
              <li>Miglioramento del servizio</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">4. Base Giuridica</h2>
            <p className="text-gray-700 mb-4">
              Il trattamento è basato su:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Esecuzione di un contratto (Art. 6.1.b GDPR)</li>
              <li>Obbligo legale (Art. 6.1.c GDPR) per dati fiscali</li>
              <li>Consenso dell'interessato (Art. 6.1.a GDPR) per marketing</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">5. Conservazione dei Dati</h2>
            <p className="text-gray-700 mb-4">
              I dati personali vengono conservati per:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Dati contrattuali: 10 anni (obblighi fiscali)</li>
              <li>Dati marketing: fino a revoca del consenso</li>
              <li>Dati navigazione: 24 mesi</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">6. Diritti dell'Interessato</h2>
            <p className="text-gray-700 mb-4">Ai sensi del GDPR, hai diritto a:</p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Accesso ai dati (Art. 15)</li>
              <li>Rettifica (Art. 16)</li>
              <li>Cancellazione (Art. 17)</li>
              <li>Limitazione del trattamento (Art. 18)</li>
              <li>Portabilità (Art. 20)</li>
              <li>Opposizione (Art. 21)</li>
              <li>Reclamo al Garante Privacy</li>
            </ul>
            <p className="text-gray-700 mb-4">
              Per esercitare i tuoi diritti, scrivi a: privacy@zonepass.io
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">7. Comunicazione a Terzi</h2>
            <p className="text-gray-700 mb-4">
              I dati possono essere comunicati a:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Provider tecnologici (hosting, email)</li>
              <li>Gateway di pagamento (Stripe)</li>
              <li>Organizzatori degli eventi</li>
              <li>Autorità competenti (su richiesta legale)</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">8. Sicurezza</h2>
            <p className="text-gray-700 mb-4">
              Adottiamo misure di sicurezza tecniche e organizzative per proteggere i dati da 
              accessi non autorizzati, perdita o distruzione, incluse: crittografia SSL/TLS, 
              backup regolari, controllo accessi, firewall.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">9. Cookies</h2>
            <p className="text-gray-700 mb-4">
              Utilizziamo cookies tecnici necessari al funzionamento del sito e, previo consenso, 
              cookies di profilazione per marketing. Puoi gestire i cookies dalle impostazioni del browser.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">10. Modifiche</h2>
            <p className="text-gray-700 mb-4">
              Ci riserviamo il diritto di modificare questa informativa. Le modifiche saranno 
              pubblicate su questa pagina con data di aggiornamento.
            </p>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mt-8">
              <p className="text-sm text-blue-900">
                <strong>Contatti:</strong><br/>
                Email: privacy@zonepass.io<br/>
                Per reclami: Garante per la Protezione dei Dati Personali - www.garanteprivacy.it
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}